import { createSlice } from "@reduxjs/toolkit";
const registrationHierarchiesSlice = createSlice({
    name: 'registrationHierarchies',
    initialState: {
        hierarchiesDetails: []
    },
    reducers: {
        setRegistrationHierarchies: (state, action) => {
            state.hierarchiesDetails = action.payload.hierarchiesDetails
        }
    }
});
export const addRegistrationHierarchies = registrationHierarchiesSlice.actions.setRegistrationHierarchies;
export default registrationHierarchiesSlice.reducer;
